<template>
    <Dialog
        v-model:visible="props.isNotifDialogVisible"
        :modal="true"
        :closable="true"
        :header="'Notifications'"
        :pt="{
            mask : {
                class : 'notifDialog-avatar'
            },
        }"
        class="p-dialog-maximized">
        <div v-if="notifyStore.getUserNotification.length">
            <DetailsNotif
                v-for="item in notifyStore.getUserNotification"
                :key="item.id"
                :item="item" />
        </div>
        <div v-else class="d-flex flex-column justify-content-center align-items-center bg-white rounded-2 h-100">
            <div class="avatar avatar-icon avatar-xl bg-primary-25 large-size mx-auto mb-4">
                <i class="material-symbols-rounded me-0 text-primary-600" style="font-size: 32px;">notifications</i>
            </div>
            <p class="text-center fsz-14" style="max-width: 562px;">
                Aucune Notification pour le Moment
            </p>
        </div>
    </Dialog>
</template>

<script setup lang="ts">
const props = defineProps({
    isNotifDialogVisible: { type: Boolean, default: false },
});

const notifyStore = useNotifyStore();

onBeforeMount(async ()=>{
    await notifyStore.fetchNotification();
})
</script>

<style scoped>
</style>
